<!--
 * @Description: 
 * @Author: 赵大壮
 * @Date: 2022-01-07 16:46:55
 * @LastEditTime: 2022-05-21 10:42:09
 * @LastEditors: 赵大壮
-->
<template>
    <div class="w-full" ref="secondView">
        <div v-if="tipShow" id="tooltip_div">{{ pointTime }}</div>
        <canvas id="is_have_video" :width="width" height="50"></canvas>
        <canvas id="time_line" :width="width" height="50"></canvas>
        <canvas id="time_line_layer" :width="width" height="50"></canvas>
    </div>
</template>

<script>
export default {
    data() {
        return {
            width: 1000,
            mouseSite: 0,
            tipShow: false,
            allowDarw: true,
        }
    },
    props: {
        currentTime: {
            default: (new Date().getTime() / 1000)
        },
        videoRecords: {
            type: Array,
            default: () => []
        }
    },
    watch: {
        currentTime(value, oldValue) {
            if (this.allowDarw) {
                this.timeChange(this.width, this.currentTime)
            }
        },
        width(value, oldValue) {
            if (this.allowDarw) {
                this.timeChange(this.width, this.currentTime)
            }
        },
        videoRecords(value, oldValue) {
            if (this.allowDarw) {
                this.timeChange(this.width, this.currentTime)
            }
        }
    },
    created() {
    },
    mounted() {
        this.timeChange(this.width, this.currentTime);
        this.addanvasEvent();
    },
    computed: {
        pointTime: {
            get: function () {
                let d = this.getTime(this.currentTime + this.mouseSite * 60 - this.currentTime % 60 - parseInt((this.width / 2 + '')) * 60)
                return `${d[0]}-${d[1]}-${d[2]} ${d[3]}:${d[4]}:${d[5]}`
            }
        }
    },
    methods: {
        /**
         * 画线
         */
        drawLine(beginX, beginY, endX, endY, color, width) {
            let canvasId = document.getElementById('time_line')
            let ctx = canvasId.getContext('2d')
            ctx.beginPath()
            ctx.moveTo(beginX, beginY)
            ctx.lineTo(endX, endY)
            ctx.strokeStyle = color
            ctx.lineWidth = width
            ctx.stroke()
        },
        pointSite(e) {
            this.mouseSite = e.layerX
            this.tipShow = true
            this.$nextTick(() => {
                let ele = document.getElementById('tooltip_div')
                ele.style.left = (e.x - 280) + 'px'
                ele.style.top = (e.y - e.layerY - 40) + 'px'
            })
        },
        /**
         * canvas事件
         */
        addanvasEvent() {
            let canvasId = document.getElementById('time_line_layer')
            canvasId.onmouseleave = e => {
                this.tipShow = false
                canvasId.onmousemove = e => {
                    this.pointSite(e)
                }
            }
            // 鼠标按下时的位置；
            let start = 0
            // 鼠标按下时的currentTime
            let oldTime = 0
            canvasId.onmousedown = (e) => {
                this.allowDarw = false
                start = e.layerX
                oldTime = this.currentTime
                canvasId.onmousemove = (e1) => {
                    this.tipShow = false
                    let end = e1.layerX
                    let current = (start - end) * 60 + oldTime
                    this.timeChange(this.width, current)
                    // emit('changCurrentTime', current)
                }
            }
            canvasId.onmouseup = (e) => {
                let end = e.layerX
                let current = (start - end) * 60 + oldTime
                this.$emit('changCurrentTime', current)
                this.allowDarw = true
                canvasId.onmousemove = e1 => {
                    this.pointSite(e1)
                }
            }
            canvasId.onmousemove = e => {
                this.pointSite(e)
            }
        },
        /**
         * 计算时间偏移并画线，时间刻度线，半时短线，小时长线,一像素代表一分钟
         */
        carveTimeScale(width, currentTime) {
            let canvasId = document.getElementById('time_line')
            let ctx = canvasId.getContext('2d')
            ctx.clearRect(0, 0, width, 50)
            // 将时间戳转为分，再减去到时间轴中部所需分数（为了将指针所指出与startTime时间等同），再取除小时的余数（方便后续刻度显示准确），得到时间戳超过整小时的分数
            let remainder = (parseInt((currentTime / 60) + '') - parseInt((width / 2) + '')) % 60
            for (var i = 0; i < width; i++) {
                // 半时刻度；
                if ((remainder + i) % 30 == 0) {
                    this.drawLine(i, 0, i, 10, 'rgb(170,180,200)', 1)
                }

                // 获取当前刻度的秒数：  当前时间加上当前刻度再减去时间轴一半的时间（当前时间处于时间轴中间），再减去当前时间取小时的余数（方便后续刻度显示准确）
                let ct = currentTime + i * 60 - currentTime % 60 - parseInt((width / 2) + '') * 60

                // 小时刻度，及显示时间；
                if ((remainder + i) % 60 == 0) {
                    this.drawLine(i, 0, i, 20, 'rgb(170,180,200)', 1)
                    let canvasId = document.getElementById('time_line')
                    let ctx = canvasId.getContext('2d')
                    ctx.font = '12px Arial'
                    let d = this.getTime(ct)
                    ctx.fillStyle = 'rgb(170,180,200)'
                    ctx.fillText(`${d[3]}:${d[4]}`, i, 25)
                }
            }
        },
        /**
         * 有视频的区域渲染颜色
         */
        carveVideoScope(width, currentTime) {
            let canvas = document.getElementById('is_have_video')
            let ctx = canvas.getContext('2d')
            ctx.clearRect(0, 0, width, 50)

            // 当前时间轴包括的时间段；
            // let maxTime = currentTime + parseInt((width / 2) + '') * 60
            // let minTime = currentTime - parseInt((width / 2) + '') * 60
            // let d = this.videoRecords.filter(item => {
            //     return parseInt(item.starttime) < maxTime && parseInt(item.endtime) > minTime
            // })
            let d = this.videoRecords

            d.map((item, index) => {
                // 当当前时间不在有视频区域，自动跳转到下一个视频区域
                if (index == 0 && parseInt(item.starttime) > currentTime) {
                    this.$emit('changCurrentTime', parseInt(item.starttime))
                }
                if (index < d.length - 1) {
                    if (parseInt(item.endtime) < currentTime && parseInt(d[index + 1].starttime) > currentTime) {
                        this.$emit('changCurrentTime', parseInt(d[index + 1].starttime))
                    }
                } else {
                    if (parseInt(item.endtime) < currentTime) {
                        this.$emit('changCurrentTime', parseInt(item.endtime))
                    }
                }

                let startPoint = (parseInt(((parseInt((item.starttime) + '') + width * 60 / 2 - currentTime + currentTime % 60) / 60) + ''))
                let endPoint = parseInt(((parseInt(item.endtime) + width * 60 / 2 - currentTime + currentTime % 60) / 60) + '')

                // 起点不能为负数，
                startPoint = startPoint > 0 ? startPoint : 0
                // 终点不能超出时间尺总长度。
                endPoint = endPoint < width ? endPoint : width

                let w = endPoint - startPoint
                ctx.fillStyle = 'rgba(50, 121, 115,0.3)'
                ctx.fillRect(startPoint, 0, w, 50)
            })
        },
        /**
         * 获取时间
         */
        getTime(timeStamp) {
            let date = new Date(timeStamp * 1000)
            let year = date.getFullYear()
            let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
            let currentDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
            let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
            let minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
            let second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
            return [year, month, currentDate, hour, minute, second]
        },
        /**
         *  当前时间改变，重绘刻度，指针，时间
         */
        timeChange(width, time) {
            this.carveTimeScale(width, time)
            // this.carveVideoScope(width, time)
            this.drawLine(parseInt((width / 2) + ''), 0, parseInt((width / 2) + ''), 35, '#00b1c3', 2)
            let canvasId = document.getElementById('time_line')
            let ctx = canvasId.getContext('2d')
            ctx.font = '12px Arial'
            ctx.fillStyle = '#00b1c3'
            let d = this.getTime(time)
            ctx.fillText(`${d[0]}-${d[1]}-${d[2]} ${d[3]}:${d[4]}:${d[5]}`, parseInt((width / 2) + '') - 50, 48)
        }

    }
}
</script>
<style lang="scss">
#time_line {
    // background-color: rgb(0, 255, 234, 0);
    position: absolute;
}

#is_have_video {
    // background-color: gray;
    position: absolute;
}

#time_line_layer {
    // background-color: rgb(0, 255, 234, 0);
    position: absolute;
}

#tooltip_div {
    background-color: rgb(50, 121, 115);
    position: absolute;
    font-size: 10px;
    width: 75px;
    text-align: center;
    color: #fff;
}
</style>
